import angular from 'angular';
import template from './tip.html';
import {TipKabineController} from './tip.controller.js';


const TipComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: TipKabineController,
    controllerAs: 'vm'
};

export {TipComponent};



// WEBPACK FOOTER //
// ./app/components/tip/tip.component.js